import React from "react";
import { Box, styled } from "@mui/material";
import DashboardFrame from "../../component/dashboard-frame";
import { IWithClassName } from "../../theme/default.theme";

interface IProps extends IWithClassName {}

const Page = ({ className }: IProps) => (
  <DashboardFrame title="">
    <Box className={className}>
      <img
        src="/assets/images/website-under-construction.jpg"
        alt="under construction"
      />
    </Box>
  </DashboardFrame>
);

export default styled(Page)(() => ({
  textAlign: "center",
}));
